import { href, Link, useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { BiArrowFromLeft } from "react-icons/bi";
import { MdArrowBackIosNew } from "react-icons/md";
import { FaChevronRight } from "react-icons/fa";

const Breadcrumb = ({ items = [{ href:"/home",label:"Home"}, { href:"/new",label:"New"}], page = "Application List" }) => {
  const navigate = useNavigate();
  return (
    <div className="p-2">
      <nav
        aria-label="breadcrumb"
        className="py-2 px-6 flex justify-between items-center border"
      >
        <ul className="flex items-center space-x-2 text-gray-600 dark:text-gray-300">
          <li className="flex">
            <button className="inline-block" onClick={() => navigate(-1)}>
              <MdArrowBackIosNew width={16} />
            </button>
          </li>
          <li className="flex">
            <Link className="font-semibold" to="/dashboard">Dashboard</Link>
          </li>
          {/* {items.map((item, index) => (
            <li key={index} className="flex items-center">
              {index > 0 && (
                <motion.span
                  initial={{ opacity: 0, x: -5 }}
                  animate={{ opacity: 1, x: 0 }}
                  transition={{ duration: 0.3 }}
                >
                  <BiArrowFromLeft className="w-4 h-4 text-gray-400" />
                </motion.span>
              )}
              <motion.div
                initial={{ opacity: 0, y: 5 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.3 }}
              >
                {item.href ? (
                  <Link
                    to={item.href}
                    className="text-blue-600 hover:underline dark:text-blue-400"
                  >
                    {item.label}
                  </Link>
                ) : (
                  <span className="text-gray-900 dark:text-white font-semibold">
                    {item.label}
                  </span>
                )}
              </motion.div>
            </li>
          ))} */}
        </ul>
        <div>
          <h2 className="text-md md:text-2xl font-semibold">{page}</h2>
        </div>
      </nav>
{/* x */}
    </div>
  );
};

export default Breadcrumb;
